<template>
  <div class="list">
    <div class="header">
      <div class="l">
        <div class="label">
          状态
        </div>
        <el-select
          v-model="searchForm.valid"
          placeholder="请选择代理商状态"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in agentList"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          />
        </el-select>
      </div>
      <div class="r">
        <el-button
          type="primary"
          @click="openAgentDialog(null)"
        >
          新建代理商
        </el-button>
      </div>
    </div>
    <data-table
      :data="tabelData"
      :table-column="tableColumn"
      :pagination="true"
      @changeBypagination="tableHandle"
      @buttonClick="buttonClick"
    />
    <!-- 新增代理商 -->
    <agent-dialog
      :dialog-visible.sync="agentDialogVisible"
      :item="agentItem"
      @confirm="getList()"
      @close="()=> agentItem = {}"
    />
    <!-- 新增代理商 -->
  </div>
</template>

<script>
import axClient from '@/services';
import dataTable from '@/components/common/dataTable.vue';
import types, { agentList } from '@/config';
import agentDialog from './dialog/agentDialog.vue';

export default {
  name: 'Order',
  components: {
    dataTable,
    agentDialog,
  },
  data() {
    return {
      agentList,
      agentDialogVisible: false,
      searchForm: {
        valids: '',
        valid: '',
        pageNum: 1,
        pageSize: 10,
      },
      agentItem: null,
      tabelData: {},
      tableColumn: [
        {
          key: 'agentName',
          label: '代理商名称',
          dataType: 'text',
        },
        {
          key: 'chargePersonName',
          label: '负责人名称',
          dataType: 'text',
        },
        {
          key: 'chargePersonPhone',
          label: '负责人电话',
          width: '100px',
          dataType: 'text',
        },
        {
          key: 'address',
          label: '联系地址',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'valid',
          label: '状态',
          width: '100px',
          dataType: 'component',
          renderProps: { [types.AGENT_ENABLE]: '启用', [types.AGENT_DISABLE]: '禁用', successKey: types.AGENT_ENABLE },
          render: () => 'status',
        },
        {
          key: 'agentAgencyCount',
          label: '推广机构数',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'agentCourseRegistrationCount',
          label: '推广课程数量',
          width: 'auto',
          dataType: 'text',
        },
        {
          key: 'agentCourseRegistrationAmount',
          label: '推广课程金额',
          width: 'auto',
          dataType: 'money',
        },
        {
          key: 'control',
          label: '操作',
          width: '240px',
          dataType: 'component',
          renderProps: [
            {
              text: '禁用', renderKey: types.AGENT_ENABLE, renderProp: 'valid', type: 'warning', eventIndex: 0, disableKey: null,
            },
            {
              text: '启用', renderKey: types.AGENT_DISABLE, renderProp: 'valid', eventIndex: 0, disableKey: null,
            },
            {
              text: '删除', renderKey: null, type: 'danger', eventIndex: 1, disableKey: null,
            },
            {
              text: '编辑', renderKey: null, type: 'primary', eventIndex: 2, disableKey: null,
            },
            {
              text: '配置', renderKey: null, type: 'info', eventIndex: 3, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    // 获取列表
    async getList(num = 1) {
      this.searchForm.pageNum = num;
      if (this.searchForm.valid === '') {
        this.searchForm.valids = [10, 30];
      } else {
        this.searchForm.valids = [this.searchForm.valid];
      }
      const result = await axClient.agent.agentPage(this.searchForm);
      const { pageNum, pageSize, total } = result;
      this.tabelData = {
        pageNum,
        pageSize,
        total,
        list: result.list,
      };
    },
    // 跳转到详情
    goDetails(item) {
      this.$router.push({ name: 'AgentDetails', params: { id: item.id } });
    },
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      switch (type) {
        case 0:
          this.confirmDialog(item);
          break;
        case 1:
          this.deleteDialog(item);
          break;
        case 2:
          this.openAgentDialog(item);
          break;
        case 3:
          this.goDetails(item);
          break;
        default:
          break;
      }
    },
    // 打开新增代理商
    async openAgentDialog(item) {
      if (item) {
        this.agentItem = await axClient.agent.agentgetDetail({
          id: item.id,
        });
      } else {
        this.agentItem = item;
      }
      this.agentDialogVisible = true;
    },
    // 下架/上架 代理商
    confirmDialog(item) {
      this.$confirm('确定启用/禁用该代理商？', '启用/禁用代理商', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async() => {
        const { id, valid } = item;
        const data = await axClient.agent.agentUpdateValid(
          {
            id,
            valid: valid === types.AGENT_ENABLE
              ? types.AGENT_DISABLE : types.AGENT_ENABLE,
          },
        );
        if (data) {
          this.$message.success('上架/下架成功');
          this.getList();
        }
      });
    },
    // 删除 代理商
    deleteDialog(item) {
      this.$confirm('确定删除该代理商？', '删除代理商', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async() => {
        const { id } = item;
        const data = await axClient.agent.agentUpdateValid(
          {
            id,
            valid: 20,
          },
        );
        if (data) {
          this.$message.success('删除成功');
          this.getList();
        }
      });
    },
    // table 改变 pagination 时间
    tableHandle(pageNum, pageSize) {
      this.searchForm.pageNum = pageNum;
      this.searchForm.pageSize = pageSize;
      this.getList(pageNum);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
